import { FieldError } from "@/common/elements/field"
import {
  ACH_ACCOUNT_HOLDER_TYPE_OPTIONS,
  ACH_ACCOUNT_TYPE_OPTIONS,
  type AchAccountHolderType,
  type AchAccountType,
} from "@/plugins/controls/common/billing-payment-helpers"

type AchPaymentFieldsProps = {
  achAccountType: AchAccountType | null
  achAccountHolderType: AchAccountHolderType | null
  onChange: (nextValue: {
    achAccountType: AchAccountType | null
    achAccountHolderType: AchAccountHolderType | null
  }) => void
  accountTypeError?: string
  accountHolderTypeError?: string
}

export function AchPaymentFields({
  achAccountType,
  achAccountHolderType,
  onChange,
  accountTypeError,
  accountHolderTypeError,
}: AchPaymentFieldsProps) {
  return (
    <div className="grid gap-3 md:grid-cols-2">
      <label className="flex flex-col gap-1 text-sm">
        <span className="font-medium">Account type</span>
        <select
          value={achAccountType ?? ""}
          onChange={(event) =>
            onChange({
              achAccountType: (event.target.value || null) as AchAccountType | null,
              achAccountHolderType,
            })
          }
          className="h-8 rounded-lg border border-input bg-background px-2.5"
          aria-invalid={accountTypeError ? true : undefined}
        >
          <option value="">Select account type</option>
          {ACH_ACCOUNT_TYPE_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <FieldError>{accountTypeError}</FieldError>
      </label>

      <label className="flex flex-col gap-1 text-sm">
        <span className="font-medium">Account holder type</span>
        <select
          value={achAccountHolderType ?? ""}
          onChange={(event) =>
            onChange({
              achAccountType,
              achAccountHolderType: (event.target.value || null) as AchAccountHolderType | null,
            })
          }
          className="h-8 rounded-lg border border-input bg-background px-2.5"
          aria-invalid={accountHolderTypeError ? true : undefined}
        >
          <option value="">Select account holder type</option>
          {ACH_ACCOUNT_HOLDER_TYPE_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <FieldError>{accountHolderTypeError}</FieldError>
      </label>
    </div>
  )
}
